import {
    AddFailedFileUploadPathAction,
    AddUploadedChunkAction,
    CreateUploadedChunksHolderAction,
    GetJobDetailsAction,
    GetJobPhaseAction,
    IncrementUploadedFilesAction,
    InitManifoldAction,
    LegacySignResourceAction,
    ProcessPublicUrlAction,
    ProcessResourceUrlAction,
    RemoveFailedFileUploadPathAction,
    SaveBatchFieldsAction,
    SetJobDetailsAction,
    SetJobMaskDataAction,
    SetJobPhaseAction,
    SetPhaseDetailsAction,
    SignResourceAction,
    UpdateFailedUploadDialogAction,
} from "../../interfaces/store/actions/job";
import {
    ADD_FAILED_FILE_UPLOAD_PATH,
    ADD_UPLOADED_CHUNK,
    CREATE_UPLOADED_CHUNKS_HOLDER,
    GET_JOB_DETAILS,
    GET_JOB_PHASE,
    INCREMENT_UPLOADED_FILES,
    INIT_MANIFOLD,
    LEGACY_SIGN_RESOURCE,
    PROCESS_PUBLIC_URL,
    PROCESS_RESOURCE_URL,
    REMOVE_FAILED_FILE_UPLOAD_PATH,
    SAVE_BATCH_FIELDS_DATA,
    SET_JOB_DETAILS,
    SET_JOB_MASK_DATA,
    SET_JOB_PHASE,
    SET_PHASE_DETAILS,
    SIGN_RESOURCE,
    UPDATE_FAILED_UPLOAD_DIALOG,
} from "./availableActions";
import {
    AddUploadedChunkPayload,
    CreateUploadedChunksHolderPayload,
    FailedUploadDialogPayload,
    JobDetails,
    JobMaskDataPayload,
    JobPhase,
    SetPhaseDetailsData,
    SignResourcePayload,
} from "../../interfaces/store/actions/payload/job";

export const getJobPhase = (): GetJobPhaseAction => ({
    type: GET_JOB_PHASE,
});

export const setJobPhase = (payload: JobPhase): SetJobPhaseAction => ({
    type: SET_JOB_PHASE,
    payload,
});

export const getJobDetails = (): GetJobDetailsAction => ({
    type: GET_JOB_DETAILS,
});

export const setJobDetails = (payload: JobDetails): SetJobDetailsAction => ({
    type: SET_JOB_DETAILS,
    payload,
});

export const setJobMaskData = (payload: JobMaskDataPayload): SetJobMaskDataAction => ({
    type: SET_JOB_MASK_DATA,
    payload,
});

export const incrementUploadedFiles = (): IncrementUploadedFilesAction => ({
    type: INCREMENT_UPLOADED_FILES,
});

export const addFailedFileUploadPath = (payload: string): AddFailedFileUploadPathAction => ({
    type: ADD_FAILED_FILE_UPLOAD_PATH,
    payload,
});

export const removeFailedFileUploadPath = (payload: string): RemoveFailedFileUploadPathAction => ({
    type: REMOVE_FAILED_FILE_UPLOAD_PATH,
    payload,
});

export const updateFailedUploadDialog = (payload: FailedUploadDialogPayload): UpdateFailedUploadDialogAction => ({
    type: UPDATE_FAILED_UPLOAD_DIALOG,
    payload,
});

export const addUploadedChunk = (payload: AddUploadedChunkPayload): AddUploadedChunkAction => ({
    type: ADD_UPLOADED_CHUNK,
    payload,
});

export const createUploadedChunksHolder = (payload: CreateUploadedChunksHolderPayload)
: CreateUploadedChunksHolderAction => ({
    type: CREATE_UPLOADED_CHUNKS_HOLDER,
    payload,
});

export const saveBatchFields = (): SaveBatchFieldsAction => ({
    type: SAVE_BATCH_FIELDS_DATA,
});

export const initManifold = (): InitManifoldAction => ({
    type: INIT_MANIFOLD,
});

export const signResource = (payload: SignResourcePayload): SignResourceAction => ({
    type: SIGN_RESOURCE,
    payload,
});

export const setPhaseDetails = (payload: SetPhaseDetailsData): SetPhaseDetailsAction => ({
    type: SET_PHASE_DETAILS,
    payload,
});

export const processPublicUrl = (payload: SignResourcePayload): ProcessPublicUrlAction => ({
    type: PROCESS_PUBLIC_URL,
    payload,
});

export const processResourceUrl = (payload: SignResourcePayload): ProcessResourceUrlAction => ({
    type: PROCESS_RESOURCE_URL,
    payload,
});

export const legacySignResource = (payload: SignResourcePayload): LegacySignResourceAction => ({
    type: LEGACY_SIGN_RESOURCE,
    payload,
});
